export default __webpack_public_path__ + "static/media/me-framework-template.e2a440c3.pptx";